import closeAllMenus from '../../core/INF-closeAllMenus';
import openModal from './openModal';
import hashChange from './hashChange';
// import ProductImages from '../../components/ProductImages/index';

const Modal = () => {
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-open-modal]')) {
      openModal(event);
    }
  });

  hashChange();
  window.addEventListener('hashchange', hashChange);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-close-modal]')) {
      const modal = document.querySelector('[data-modal].Modal--open');
      if (modal) {
        const eventModalWillClose = new CustomEvent('modalWillClose', { detail: modal });
        document.dispatchEvent(eventModalWillClose);

        closeAllMenus();

        const eventModalDidClose = new CustomEvent('modalDidClose', { detail: modal });
        document.dispatchEvent(eventModalDidClose);
        const eventScroll = new Event('scroll');
        document.dispatchEvent(eventScroll);

        if (modal.id === 'QuickView') {
          const quickViewContent = document.querySelector('[data-quick-view-content]');
          if (quickViewContent) {
            quickViewContent.innerHTML = '';
            // ProductImages(true);
          }
        }
      }
    }
  });

  window.addEventListener('breakpointChange', () => {
    const stateModalOpen = document.querySelector('[data-state].State--modal-open');
    if (!stateModalOpen) {
      return;
    }

    // Refiring openModal will readjust positioning
    const modal = document.querySelector('[data-modal].Modal--open');
    if (modal) {
      openModal(modal);
    }
  });
};

export { Modal };
